import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Heading, Card, CardBody, Button, Text } from '@pancakeswap-libs/uikit'
import { useWeb3React } from '@web3-react/core'


const NFTDetailCard = styled(Card)`
  background-image: url('/images/nft_img.png');
  background-repeat: no-repeat;
  background-position: right -20px;
`

const Block = styled.div`
  margin-bottom: 16px;
`

const CardImage = styled.img`
  margin-bottom: 16px;
`

const Label = styled.div`
  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 14px;
`

const Actions = styled.div`
  margin-top: 24px;
`

const FarmedStakingCard = () => {
  return (
    <NFTDetailCard className="white_box home_nft_box">
      <CardBody>
        <h2>Non-Fungible Tokens</h2>
        <div className="row">
          <div className="col-md-6">
            <p>Get started with the easiest and most secure platform to mint, buy and sell NFT</p>
            <a href="https://nft.pankuku.net/"><Button>Buy Now</Button></a>
          </div>
          <div className="col-md-6">
            {/* <img src="/images/nft_img.png" alt="Icon" style={{marginLeft:"8px"}} /> */}
          </div>
        </div>
      </CardBody>
    </NFTDetailCard>
  )
}

export default FarmedStakingCard
